export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fd1f26275fff1805c2f7f974e4c47e56e2ea33b51&name=fetchTypeahead!'